import type {
  DevModeLifecycleHookEvent,
  DevModeSnippetIcon
} from '@cli-types/next-adapter/generators.js'
export function lifecycleHookIcon(event: DevModeLifecycleHookEvent): DevModeSnippetIcon {
  if (event.endsWith('Create')) return 'plus'
  if (event.endsWith('Update')) return 'pencil'
  if (event.endsWith('Delete')) return 'trash'
  if (event.endsWith('Publish')) return 'send'
  return 'save'
}
